module.exports = __webpack_public_path__ + "297ca1d6080c7511b08dfee7826a8000.jpg";